export class UserModel {
    id: number = 0;
    userId?: number = -1;
    userName: string = '';
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    password: string = '';
    phoneNumber: string = '';
    gender: string = '';
    dateOfBirth: Date = new Date();
    isSuccess: boolean = false;
    message: string[] = [];
    zip: string = '';
    token: string = '';
}
export class UserLogin {
    email: string = '';
    password: string = '';
}
export class Email {
    email: string = '';
    canEditEmail: boolean = true;
}

export interface IResetPassword {
    email: string;
    username: string;
    current: string | Date
    expiration: string | Date;
}